<template>
  <v-container grid-list-lg class="fraction-eg-union">
    <!--  -->
    <v-card class="card-style text-center mb-3 pa-4">
      <p class="lead">
        Столица нашей фракции-славная Эвриала. Большая часть населения системы расположена на самой большой станции в системе-EG Main HQ, вращающейся вокруг планеты земного типа EG Prime. История нашей родной системы восходит к тем временам, когда первые колониальные корабли начали бороздить просторы нашей Галактики. Это давно прошедшее время оставило нам историю, из которой мы черпаем вдохновение.
      </p>
    </v-card>
    <v-card class="card-style text-center mb-3 pa-4">
      <p class="lead">
        <span>"РОЖДЕНИЕ ЭВРИАЛЫ"</span>
        <br>
        <span>Во времена массовой экспансии человечества колониальный корабль «Euryale», названный так в честь одной из сестер-горгон из греческой мифологии, чьё имя переводится как «далеко прыгающая», отправился в далекий космос для основания новой земной колонии. Во время перелета вышло из строя навигационное оборудование и корабль, сойдя с проложенного курса, устремился в неизведанное. Колонисты понимали, что только невероятная удача может вывести их к пригодной для жизни звездной системе, поэтому, когда их корабль оказался у неизвестной до этого звезды с большой планетарной системой, они в благодарность назвали ее «Euryale» в честь корабля, а обнаружив в системе землеподобную планету, назвали ее «Euryale Gaia» , то есть «Земля Эвриалы». Со временем название сократилось до “EG”, а в дальнейшем приставка EG стала добавляться и к названиям космических станций и другим возникшим в системе структурам, в том числе и сообществу вольных пилотов, которое стали называть EG Pilots.</span>
      </p>
    </v-card>
    <!--  -->
    <v-row dense class="d-flex justify-center flex-wrap">
      <!-- col 1 -->
      <v-col cpls="12" sm="4">
        <v-row dense class="flex-column">
          <v-col>
            <v-card class="card-style pa-3" :href="'/img/fraction/egu-constellation.jpg'" target='_blank'>
              <v-img class="rounded" :lazy-src="require('@/assets/animate-logo-white.svg')" :src="'/img/fraction/egu-constellation-preview.jpg'" />
            </v-card>
          </v-col>
          <v-col>
            <v-card class="card-style">
              <v-card-title class="headline">Мы - воины</v-card-title>
              <v-card-text>Наша история это история войны. Войны с непрошеными гостями, войны за свою независимость, войны за свое будущее. Из этих войн мы вышли закаленными солдатами, готовыми по первому зову нашего вождя, стать единым флотом, сокрушающем всё на своем пути. Присоединяйся сейчас и мы дадим тебе самое главное - цель! Цель на войне и цель в жизни!</v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="card-style">
              <v-card-title class="headline">Мы - исследователи</v-card-title>
              <v-card-text>Десятки наших исследователей регулярно отправляются в неизведанные уголки галактики. Присоединяйся к экспедициям, встреться с нашими пилотами за тысячи световых лет, впиши своё имя в зал славы первооткрывателей! Ad Astra, CMDR!</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <!-- col 2 -->
      <v-col cpls="12" sm="4">
        <v-row dense class="flex-column">
          <v-col>
            <v-card class="card-style">
              <v-card-title class="subheading text-center">
                <div>
                  <p>Сотни пилотов объединенных одной целью</p>
                  <p>Разнообразные задачи от командования фракции</p>
                  <p>Игра во всех режимах (Open, Solo, Private Group)</p>
                  <p>Всевозможные ивенты</p>
                  <p>Совместные полеты и сражения</p>
                  <p>UПомощь по игре</p>
                  <p>Возможность развития для каждого участника</p>
                </div>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="card-style card-bounce" :to="`/euryale-chronicles`">
              <v-img class="rounded" :lazy-src="require('@/assets/animate-logo-white.svg')" :src="'/img/fraction/chronics_banner.jpg'" />
            </v-card>
          </v-col>
          <v-col>
            <v-card class="card-style">
              <v-card-title class="headline">Мы - строители</v-card-title>
              <v-card-text>Мы совместно строим наше будущее! Мы проводим экспансии в ближайшие системы и неуклонно расширяем свое влияние. Мы стараемся контролировать все объекты в принадлежащих нам системах. Под руководством нашего мудрого Диктатора мы строим лучший мир!</v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="card-style">
              <v-card-title class="headline">Мы - торговцы</v-card-title>
              <v-card-text> В EG Union нашли пристанище сотни звездных торговцев со всех уголков обитаемой галактики. Удачное расположение на границе Сил делает наши системы привлекательными для предпринимателей всех уровней. Присоединяйся и мы покажем тебе самые выгодные и безопасные торговые маршруты.</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <!-- col 3 -->
      <v-col cpls="12" sm="4">
        <v-row dense class="flex-column">
          <v-col>
            <v-card class="card-style pa-3" :href="'/img/fraction/egu-hq.jpg'" target='_blank'>
              <v-img class="rounded" :lazy-src="require('@/assets/animate-logo-white.svg')" :src="'/img/fraction/egu-hq.jpg'" />
            </v-card>
          </v-col>
          <v-col>
            <v-card class="card-style">
              <v-card-title class="headline">Мы - охотники</v-card-title>
              <v-card-text> Положение наших систем делает их излюбленным местом обитания пиратов, контрабандистов и охотников за головами. Любишь кураж и звонкую монету - тебе точно к нам! Мы никогда не были против незаконной торговли. Мы всегда поддержим любого баунтихантера. Если ты пират - мы всегда тебе рады, особенно если за тебя назначена большая награда ;)</v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="card-style">
              <v-card-title class="headline">Мы - защитники</v-card-title>
              <v-card-text>Любой присоединившийся к фракции EG Union - может рассчитывать на нашу поддержку. Мы обеспечиваем защиту и поддержку во всех наших системах. Мы выдвигаемся по первому зову к пилотам попавшим в "неприятную" ситуацию. Своих не бросаем! Никогда!</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <!--  -->
    </v-row>
  </v-container>
</template>

<script>
export default {
    components: {
        // EuryaleChronicles
    },
    data: () => ({})
}
</script>